import { useRef, useState } from "react";
import { useReactToPrint } from "react-to-print";

import { Button } from "primereact/button";
import { Card } from "primereact/card";
import { Calendar } from "primereact/calendar";
import { Toast } from "primereact/toast";
import { Dropdown } from "primereact/dropdown";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";

import Menu from "../components/Menu";
import api from "../services/api";
import html2pdf from "html2pdf.js";

export default function RelatorioManutencao() {
    const [data, setData] = useState([]);
    const [initialDate, setInitialDate] = useState(null);
    const [finalDate, setFinalDate] = useState(null);
    const [tipo, setTipo] = useState(null);
    const [tipoPesquisado, setTipoPesquisado] = useState(null);
    const [buscou, setBuscou] = useState(false);
    const [printing, setPrinting] = useState(false);
    const [condicao, setCondicao] = useState(null)
    
    const toast = useRef(null);
    const componentRef = useRef(null);

    const tiposOpcoes = [
        { label: 'Troca de Óleo de Tear', value: 'tear' },
        { label: 'Troca de Óleo de Maquineta', value: 'maquineta' }
    ];

    const condicoesOpcoes = [
        { label: 'Trocas já Feitas', value: 'trocasfeitas' },
        { label: 'Projeção de Trocas', value: 'trocasprojecao' }
    ];

    const handleSearch = () => {
        if (!tipo) {
            toast.current.show({ summary: 'Atenção', severity: 'warn', detail: 'Selecione o tipo (Tear ou Maquineta).' });
            return;
        }

        let formated1 = null;
        let formated2 = null;

        if (initialDate) {
            const year1 = initialDate.getFullYear();
            const month1 = (initialDate.getMonth() + 1).toString().padStart(2, '0');
            formated1 = `${year1}-${month1}-01`;
        }

        if (finalDate) {
            const year2 = finalDate.getFullYear();
            const month2 = finalDate.getMonth() + 1;
            const lastDay = new Date(year2, month2, 0).getDate(); 
            const formattedMonth2 = month2.toString().padStart(2, '0');
            formated2 = `${year2}-${formattedMonth2}-${lastDay}`;
        }

        let url = `relatorio-manutencao/${tipo}`;
        if (formated1)  url += `/${formated1}`;
        if (formated2)  url += `/${formated2}`;
        if (condicao)   url += `/${condicao}`;

        api.get(url).then((response) => {
            setData(response.data);
            setTipoPesquisado(tipo);
            setBuscou(true);
            toast.current.show({ summary: 'Concluído', severity: 'success', detail: 'Relatório gerado com sucesso.' });
        }).catch((error) => {
            setBuscou(true);
            toast.current.show({ summary: 'Ocorreu um Erro', severity: 'error', detail: error.response ? error.response.data.message : error.message });
        });

    }

    const handlePrint = useReactToPrint({
        content: () => componentRef.current,
        onBeforeGetContent: () => {
            return new Promise((resolve) => {
                setPrinting(true);
                setTimeout(() => {
                    resolve();
                }, 500);
            });
        },
        onAfterPrint: () => {
            setPrinting(false);
        }
    });

    const handlePdf = () => {
        const element = componentRef.current;
        
        const opt = {
            margin: 10,
            filename: `Relatorio_Manutenção-${tipo}.pdf`,
            image: { type: 'jpeg', quality: 0.98 },
            html2canvas: { scale: 2, useCORS: true },
            jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' }
        };

        setPrinting(true);

        html2pdf().set(opt).from(element).save().then(() => {
            setPrinting(false);
        });
    };
    

    const formatarData = (dataOriginal) => {
        if (!dataOriginal) return "-";
        const d = new Date(dataOriginal);
        d.setMinutes(d.getMinutes() + d.getTimezoneOffset());
        return d.toLocaleDateString('pt-BR');
    };

    const proximaTrocaTemplate = (rowData) => {
        if (!rowData.data_troca || !rowData.validade) return "-";

        const dataVencimento = new Date(rowData.data_troca);
        dataVencimento.setMinutes(dataVencimento.getMinutes() + dataVencimento.getTimezoneOffset());
        dataVencimento.setFullYear(dataVencimento.getFullYear() + Number(rowData.validade));
        dataVencimento.setHours(0, 0, 0, 0);

        const hoje = new Date();
        hoje.setHours(0, 0, 0, 0);

        const limiteAlerta = new Date(hoje);
        limiteAlerta.setMonth(limiteAlerta.getMonth() + 3);

        const isVencido = dataVencimento < hoje;
        const isProximoVencimento = dataVencimento >= hoje && dataVencimento <= limiteAlerta;
        
        const dataFormatada = dataVencimento.toLocaleDateString('pt-BR');

        if (isVencido) {
            return (
                <div style={{ color: '#c63737', fontWeight: '500', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '6px' }}>
                    <i className="pi pi-times-circle"></i>
                    {dataFormatada}
                </div>
            );
        }

        if (isProximoVencimento) {
            return (
                <div style={{ color: '#b59f00', fontWeight: '500', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '6px' }}>
                    <i className="pi pi-exclamation-triangle"></i>
                    {dataFormatada}
                </div>
            );
        }

        return (
            <div style={{ color: '#2e7d32', fontWeight: '500', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '6px' }}>
                {dataFormatada}
            </div>
        );
    };

    return (
        <div>
            <Menu />
            <Toast ref={toast} />
            <Card className="p-m-3" title="Relatório Manutenção">
                <div className="p-fluid p-grid p-align-end">
                    <div className="p-field p-col-12 p-md-1">
                        <label>Mês Inicial</label>
                        <Calendar
                            view="month"
                            dateFormat="mm/yy"
                            mask="99/9999"
                            onChange={e => setInitialDate(e.value)}
                            value={initialDate}
                        />
                    </div>
                    <div className="p-field p-col-12 p-md-1">
                        <label>Mês Final</label>
                        <Calendar
                            view="month"
                            dateFormat="mm/yy"
                            mask="99/9999"
                            onChange={e => setFinalDate(e.value)}
                            value={finalDate}
                        />
                    </div>
                    <div className="p-field p-col-12 p-md-2">
                        <label>Condição</label>
                        <Dropdown
                            options={condicoesOpcoes}
                            onChange={e => setCondicao(e.value)}
                            placeholder="Selecione a Condição"
                            value={condicao}
                        />
                    </div>
                    <div className="p-field p-col-12 p-md-2">
                        <label>Tipo</label>
                        <Dropdown
                            options={tiposOpcoes}
                            onChange={e => setTipo(e.value)}
                            placeholder="Selecione Tear ou Maquineta"
                            value={tipo}
                        />
                    </div>
                    <div className="p-field p-col-12 p-md-5" style={{ display: 'flex', gap: '8px' }}>
                        <Button 
                            className="p-button-primary" 
                            icon="pi pi-search" 
                            onClick={handleSearch} 
                        />
                    </div>
                </div>
                {buscou && (
                    <>
                        <hr style={{ border: 'none', borderTop: '1px solid #ddd'}} />
                        <div style={{ display: 'flex', gap: '8px', margin: '1rem 0' }}>
                            <Button 
                                className="p-button-primary" 
                                icon={printing ? "pi pi-spin pi-spinner" : "pi pi-print"} 
                                onClick={handlePrint} 
                                disabled={!buscou || data.length === 0 || printing} 
                                title="Imprimir Relatório" 
                            />
                            <Button 
                                className="p-button-danger"
                                icon={printing ? "pi pi-spin pi-spinner" : "pi pi-file-pdf"}
                                onClick={handlePdf}
                                disabled={!buscou || data.length === 0 || printing}
                                title="PDF do Relatório" 
                            />
                        </div>

                        <div ref={componentRef} style={{ margin: '1rem 2.3rem', borderRadius: '8px', boxShadow: '0 4px 10px rgba(0,0,0,0.03)', border: '1px solid #e0e0e0', overflow: 'hidden'}}>
                            <h4 style={{ 
                                fontSize: '16px', 
                                margin: 0, 
                                padding: '16px 20px', 
                                borderBottom: '2px solid #2196F3', 
                                backgroundColor: '#f8f9fa',
                                color: '#495057',
                                display: 'flex',  
                                justifyContent: 'space-between', 
                                alignItems: 'center'
                            }}>
                                <span>
                                    <i className="pi pi-list" style={{ marginRight: '8px', color: '#2196F3' }}></i>
                                    Histórico de Óleo de <span style={{ textTransform: 'capitalize' }}>{tipoPesquisado}</span>
                                    <span>
                                    {initialDate && finalDate ? 
                                        ` — ${initialDate.toLocaleDateString('pt-BR', {  month: 'short', year: 'numeric', })} 
                                        até ${finalDate.toLocaleDateString('pt-BR', { month: 'short', year: 'numeric', })}`
                                        : ''}
                                    </span>
                                </span>
                                <span style={{ fontSize: '13px', fontWeight: 'normal' }}>
                                    {data.length} {data.length === 1 ? 'registro' : 'registros'}
                                </span>
                            </h4>
                            
                            <div>
                                <DataTable 
                                    value={data} 
                                    emptyMessage="Nenhum registro encontrado para o período selecionado." 
                                    stripedRows 
                                    rowHover 
                                    responsiveLayout="scroll"
                                >
                                    <Column field="numero_tear" header={tipoPesquisado === 'maquineta' ? 'N° Tear Maquineta' : 'N° Tear'} style={{ paddingLeft: '20px', fontWeight: '500' }} />
                                    <Column field="marca_oleo" header="Marca Óleo" />
                                    <Column field="data_troca" header="Última Troca" body={(rowData) => formatarData(rowData.data_troca)} align="center" />
                                    <Column header="Próxima Troca" body={proximaTrocaTemplate} align="center" style={{ paddingRight: '20px' }} />
                                </DataTable>
                            </div>
                        </div>
                    </>
                )}
            </Card>
        </div>
    )
}